module.exports = __webpack_public_path__ + "static/media/Follower_Button-14.28766fbd.png";